export type ThaiBankCode =
  | 'SCB'
  | 'KBANK'
  | 'KTB'
  | 'BAY'
  | 'BBL'
  | 'ttb'
  | 'CIMB'
  | 'CITI'
  | 'GHB'
  | 'GSB'
  | 'HSBC'
  | 'IBANK'
  | 'ICBC'
  | 'KKP'
  | 'LHB'
  | 'TCRB'
  | 'TISCO'
  | 'UOB'
  | 'BAAC'

export const THAI_BANK_OPTIONS: ReadonlyArray<{ code: ThaiBankCode; label: string }> = [
  { code: 'SCB', label: 'ธนาคารไทยพาณิชย์ (SCB)' },
  { code: 'KBANK', label: 'ธนาคารกสิกรไทย (KBANK)' },
  { code: 'KTB', label: 'ธนาคารกรุงไทย (KTB)' },
  { code: 'BAY', label: 'ธนาคารกรุงศรีอยุธยา (BAY)' },
  { code: 'BBL', label: 'ธนาคารกรุงเทพ (BBL)' },
  { code: 'ttb', label: 'ธนาคารทหารไทยธนชาต' },
  { code: 'CIMB', label: 'ธนาคารซีไอเอ็มบี (CIMB)' },
  { code: 'CITI', label: 'ธนาคารซิตี้แบงก์ (CITI)' },
  { code: 'GHB', label: 'ธนาคารอาคารสงเคราะห์ (GHB)' },
  { code: 'GSB', label: 'ธนาคารออมสิน (GSB)' },
  { code: 'HSBC', label: 'ธนาคารเอชเอสบีซี (HSBC)' },
  { code: 'IBANK', label: 'ธนาคารอิสลามแห่งประเทศไทย (IBANK)' },
  { code: 'ICBC', label: 'ธนาคารไอซีบีซี (ICBC)' },
  { code: 'KKP', label: 'ธนาคารเกียรตินาคินภัทร (KKP)' },
  { code: 'LHB', label: 'ธนาคารแลนด์ แอนด์ เฮ้าส์ (LHB)' },
  { code: 'TCRB', label: 'ธนาคารไทยเครดิต (TCRB)' },
  { code: 'TISCO', label: 'ธนาคารทิสโก้ (TISCO)' },
  { code: 'UOB', label: 'ธนาคารยูโอบี (UOB)' },
  { code: 'BAAC', label: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (BAAC)' },
]

const bankLabelByCode = new Map<string, string>(
  THAI_BANK_OPTIONS.map((o) => [o.code, o.label]),
)

export function getThaiBankLabel(code: string | undefined): string | undefined {
  if (!code) return undefined
  return bankLabelByCode.get(code)
}

export function bankIconPublicPath(code: string): string {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
  return `${base}/images/bank-icons/${code}.png`
}
